module.exports = __webpack_public_path__ + "static/claps.72ac5c6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/partners/claps.png
// module id = 1612
// module chunks = 35783957827783